// import { GoogleMap, useJsApiLoader, Marker } from '@react-google-maps/api';
import { Container } from './styles';

export function Local() {

    // const { isLoaded } = useJsApiLoader({
    //     id: 'google-map-script',
    //     googleMapsApiKey: "AIzaSyD9rUSal-s-x-K99hzfhx93LfgKkGO37lc"        
    // })

    // const position = {
    //     lat: -5.949583,
    //     lng: -35.180177
    // }

    return (
        <Container id="local">
            <h1>Local</h1>
            <h2>Espaço Di Trento</h2>
            {/* {isLoaded ? (
                <GoogleMap
                    mapContainerStyle={{ width: '100%', height: '100%' }}
                    center={position}
                    zoom={15}
                >
                    <Marker position={position} options={{
                        label: {
                            text: "Casamento Wellton e Renata",
                            className: "map-marker",
                        }
                    }} />
                </GoogleMap>
            ) : <></>
            } */}
            <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3968.3270157747866!2d-35.18273568603246!3d-5.949597660159368!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7b2f7879017d46f%3A0xd33f647445681592!2sEspa%C3%A7o%20Di%20Trento!5e0!3m2!1spt-BR!2sbr!4v1655905794685!5m2!1spt-BR!2sbr" 
                width="100%" 
                height="100%" 
                style={{border: 0}} 
                allowFullScreen="" 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"
                title="Local do casamento Renata e Wellton"    
            >                   
                </iframe>
        </Container>
    );
}